export default __webpack_public_path__ + "static/quote-slider-light-background-06d91919fdfab2d74413626b93789f9b.webp";